(function() {
    'use strict';

    angular
        .module('sodCommon')
        .factory('Request', RequestFactoryFunc);

    function RequestFactoryFunc(Path) {
        var updated = null;
        var models = {};
        return {
            /**
             * creates a request object used for executing a api call
             * @param method - GET/POST/PUT/DELETE
             * @param route - uri of the service.
             * @param event - the event that activates this request call
             * @param eventData  - the eventData from the event
             * @param data - Data to send over to the api
             */
            run: function(method, route, event, eventData, data) {
                var update = new Date().getTime();
                if (method == 'delete') data = {};
                if (!data) data = {};
                models[update] = new RequestModel(method, route, event, eventData, data);
                updated = angular.copy(update);
            },
            /**
             * Method to determine if a new request is created and pending for executing (Used at ContentController)
             * @returns (Integer) updated - the last updated time
             */
            requestUpdated: function() {
                return updated;
            },
            /**
             * get the request object necessary to do a request call
             * @returns (Object) request - contains information like method, uri, data, event
             */
            getRequest: function() {
                var result = angular.copy(models);
                models = {};
                return result;
            }
        };

        // require model stores the relavent information for a request
        function RequestModel(method, route, event, eventData, data) {
            return {
                getMethod: function() { return method.toLowerCase(); },
                getRoute: function() { return route; },
                getData: function() {
                    return {
                        path:  Path.getPathInfo().viewPath(),
                        event: event,
                        data :data
                    };
                },
                getElement: function() { return eventData.target; },
                getElementScope: function() { return eventData.targetScope; },
                getEventData: function() { return eventData; }
            };
        }
    }
})();